var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#128C4B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B6C38",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h21v15H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M0 0h21v15H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9h8v-.992c0-.28.193-.412.453-.281L14 8v1h1.495c.279 0 .505.214.505.505V10c0 .552-.443 1-.999 1h-1.506a.503.503 0 01-.495-.5V10H6.503c-.278 0-.66-.156-.853-.35L5 9zm0-2.748c0-.139.078-.33.18-.433l.14-.138c.1-.1.102-.26 0-.362l-.14-.138A.69.69 0 015 4.748v-.496C5 4.113 5.107 4 5.252 4h.496c.139 0 .252.107.252.252v.496c0 .139.046.16.116.02l.268-.536A.459.459 0 016.748 4h1.004C7.89 4 8 4.116 8 4.25c0 .138-.107.25-.252.25h-.496A.254.254 0 007 4.75c0 .138.107.25.252.25h.496c.139 0 .252.108.252.245v1.51A.245.245 0 017.748 7h-.496A.249.249 0 017 6.748v-.496C7 6.113 7.116 6 7.25 6c.138 0 .25-.116.25-.25a.247.247 0 00-.252-.25h-.496a.255.255 0 00-.252.248v1.004A.251.251 0 016.25 7 .247.247 0 016 6.748v-.496A.254.254 0 005.75 6a.247.247 0 00-.25.252v.496A.254.254 0 015.25 7 .247.247 0 015 6.748v-.496zm8 0c0-.139.078-.33.18-.433l.14-.138c.1-.1.102-.26 0-.362l-.14-.138a.69.69 0 01-.18-.433v-.496c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496c0 .139.046.16.116.02l.268-.536A.459.459 0 0114.748 4h1.004c.137 0 .248.116.248.25 0 .138-.107.25-.252.25h-.496a.254.254 0 00-.252.25c0 .138.107.25.252.25h.496c.139 0 .252.108.252.245v1.51a.245.245 0 01-.252.245h-.496A.249.249 0 0115 6.748v-.496c0-.139.116-.252.25-.252.138 0 .25-.116.25-.25a.247.247 0 00-.252-.25h-.496a.255.255 0 00-.252.248v1.004a.251.251 0 01-.25.248.247.247 0 01-.25-.252v-.496A.254.254 0 0013.75 6a.247.247 0 00-.25.252v.496a.254.254 0 01-.25.252.247.247 0 01-.25-.252v-.496zm-1-1.504c0 .139-.078.33-.18.433l-.14.138c-.1.1-.102.26 0 .362l.14.138c.1.1.18.288.18.433v.496a.248.248 0 01-.252.252h-.496A.249.249 0 0111 6.748v-.496c0-.139-.046-.16-.116-.02l-.268.536a.459.459 0 01-.364.232H9.248A.251.251 0 019 6.75c0-.138.107-.25.252-.25h.496A.254.254 0 0010 6.25.247.247 0 009.748 6h-.496A.247.247 0 019 5.755v-1.51C9 4.11 9.107 4 9.252 4h.496c.139 0 .252.107.252.252v.496A.254.254 0 019.75 5a.253.253 0 00-.25.25c0 .138.107.25.252.25h.496a.255.255 0 00.252-.248V4.248c0-.137.116-.248.25-.248.138 0 .25.107.25.252v.496c0 .139.116.252.25.252.138 0 .25-.107.25-.252v-.496c0-.139.116-.252.25-.252.138 0 .25.107.25.252v.496z",
    fill: "url(#a)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSa);
export default __webpack_public_path__ + "static/media/SA.22adc8b433b85575dc4a3e8e582724c9.svg";
export { ForwardRef as ReactComponent };